// extracted by mini-css-extract-plugin
export var deliveryRow = "_q5-a";
export var fixedHeight = "_q5-4";
export var freightLogo = "_q5-9";
export var fullWidth = "_q5-3";
export var priceColumn = "_q5-5";
export var radioSelected = "_q5-7";
export var radioUnselected = "_q5-6";
export var selectedOption = "_q5-2";
export var selectedOptionContainer = "_q5-1";
export var selection = "_q5-0";
export var tallSkeletonText = "_q5-8";